// extracted by mini-css-extract-plugin
module.exports = {"contentWrap":"Head_contentWrap__1rABc","content":"Head_content__1SCpK"};